import {
    type FC
} from "react";
import type IDropdownMenuStatusProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuStatus: FC<IDropdownMenuStatusProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    ...props
}) => {
    const context = useDropdownMenuContext({
        part: "Status"
    });

    return <PopoverSurface.Status
        {...props}
        customLocalize={customLocalizeProp ?? context?.customLocalize}
        customTheme={customThemeProp ?? context?.customTheme}
    />;
};
export default DropdownMenuStatus;
